import Debug from '../../helpers/debug.js';
import YAML from 'yaml';
import Table from 'cli-table';
import { getProfileConfigFilePath, getProfileConfig, writeConfigFile } from '../../helpers/config.js';
import { pp, pr, printJSON } from '../../helpers/print.js';

const debug = Debug('commands:config:set');

const command = 'set <setting> <value>';

const desc = 'Set configuration key-value pairs';

const builder = async (yargs) => {
  debug('builder', command, yargs);
  yargs
    .option('setting', {
      describe: 'The configuration parameter you wish to set',
      type: 'string',
    })
    .option('value', {
      describe: "The configuration parameter's value",
      type: 'string',
    });

  return yargs;
};

const handler = async (argv) => {
  debug('handler', command, argv);

  const { json, setting, value } = argv;
  const allowedSettings = ['apikey'];

  if (!allowedSettings.includes(setting)) {
    json
      ? printJSON({ status: 'error', error: 'Invalid settings parameter' })
      : console.error('Invalid settings parameter');
    // throw new Error('Invalid settings parameter');
    return;
  }

  try {
    const profileConfig = await getProfileConfig();
    if (profileConfig && profileConfig.config) !json && pp('Updating profile config file...');
    else !json && pp('Creating profile config file...');

    const data =
      profileConfig && profileConfig.config ? { ...profileConfig.config, [setting]: value } : { [setting]: value };
    const yamlData = YAML.stringify(data);

    const filePath = profileConfig && profileConfig.filepath ? profileConfig.filepath : getProfileConfigFilePath();

    await writeConfigFile(filePath, yamlData);
    json ? printJSON({ status: 'success' }) : pp('Done').pr();
  } catch (err) {
    json ? printJSON({ status: 'error', error: err }) : console.log(err);
  }
};

export { command, desc, builder, handler };
